package us.laantech.laanmanage.feature.store.department

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.parameter
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.HttpStatusCode
import io.ktor.http.contentType
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch
import us.laantech.common.dto.company.CompanyBranch
import us.laantech.common.dto.company.Department
import us.laantech.common.api.KtorClient


data class StoreDepartmentsViewUiState(
    val departments: List<Department> = emptyList(),
    val showCreateEditDepartmentModal: Boolean = false,
)


class StoreDepartmentsViewModel(): ViewModel() {

    private val _uiState = MutableStateFlow(StoreDepartmentsViewUiState())
    val uiState = _uiState.asStateFlow()
    private val ktClient = KtorClient.instance.client
    val scope = CoroutineScope(Dispatchers.Default)

    fun loadDepartments(companyBranch: CompanyBranch?) {
        scope.launch {
            val response = ktClient.get("/backoffice/store-management/products/departments/list") {
                parameter(CompanyBranch::uuid.name, companyBranch?.uuid)
            }
            val departments = response.body<List<Department>>()
            _uiState.value = _uiState.value.copy(departments = departments)
        }
    }

    fun toggleCreateEditDepartmentModal() {
        _uiState.update {
            it.copy(showCreateEditDepartmentModal = !it.showCreateEditDepartmentModal)
        }
    }

    fun createDepartment(deptUUID: String, text: CharSequence, text2: CharSequence, i: Int) {

        val body = Department(
            departmentUUID = deptUUID,
            departmentName = text.toString(),
            ageLimit = i
        )

        viewModelScope.launch {
            // TODO use backoffice api
            val response = ktClient.post("/pos/products/department") {
                contentType(ContentType.Application.Json)

                // TODO remove hardcoded branch_uuid
                parameter("branch_uuid", "5314abfd-84df-433d-9a1a-d6b3a762e31f")
                setBody(body)
            }

            if (response.status == HttpStatusCode.Created) {
                toggleCreateEditDepartmentModal()
                _uiState.update { it.copy(departments = it.departments + body) }
            }

        }

    }

}
